import { useSettings } from "@hooks/useSettings";
import { useTemplate } from "@hooks/useTemplate";
import { useLocalisationContext } from "@hooks/useLocalisation";
import {
  type ComponentProps,
  type NormalisedProductVariant,
} from "@ts/components";
import React, {
  useState,
  type Dispatch,
  type FC,
  type SetStateAction,
} from "react";

export type FindInStoreInputProps = ComponentProps & {
  selectedVariant?: NormalisedProductVariant;
};

export type FindInStoreOutputProps = FindInStoreInputProps & {
  active: boolean;
  additionalFindInStore?: string;
  countryCode?: string;
  errorActive: boolean;
  handleClick: () => void;
  setActive: Dispatch<SetStateAction<boolean>>;
  setErrorActive: Dispatch<SetStateAction<boolean>>;
};

export const withFindInStore =
  (Component: FC<FindInStoreOutputProps>) =>
  ({ name = "FindInStore", selectedVariant }: FindInStoreInputProps) => {
    const [active, setActive] = useState(false);
    const [errorActive, setErrorActive] = useState(false);
    const { findInStore } = useSettings();
    const { contextCountry } = useLocalisationContext();
    const { enabled } = findInStore || {};
    const {
      product: { additionalFindInStore },
    } = useTemplate();

    const handleClick = () => {
      if (!selectedVariant) {
        setErrorActive(true);
        return;
      }
      setActive((prev) => !prev);
    };

    Component.displayName = name;

    if (!enabled) {
      return null;
    }

    return (
      <Component
        active={active}
        additionalFindInStore={additionalFindInStore}
        countryCode={contextCountry}
        errorActive={errorActive}
        handleClick={handleClick}
        selectedVariant={selectedVariant}
        setActive={setActive}
        setErrorActive={setErrorActive}
      />
    );
  };
